var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "fb",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "vFb") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M64,4A60,60,0,1,1,4,64,60,60,0,0,1,64,4Zm5.59,46.72c0-3-.12-5.79,0-8.55.1-1.85,1.28-2.72,3.2-2.74,2.69,0,5.37,0,8.14,0V26.85c-4.84,0-9.61-.31-14.33.08a12.45,12.45,0,0,0-11.4,8.92,27.7,27.7,0,0,0-1.11,6.87c-.19,2.59,0,5.2,0,8H46.81V63.76h7.28V100.7H69.52v-37H79.89c.45-4.36.88-8.59,1.34-13Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ddfcea31fcd1388a416d03cc1a9f9d01.svg";
export { ForwardRef as ReactComponent };